module.exports = __webpack_public_path__ + "img/google.9c57e072.svg";